export const caseValidationRules = {
    //admission section
    admissionDate   : null,
    age             : null,
    weight          : null,
    height          : null,
    bmi             : null,
    admissionAOGType: null,
    caseFormType    : null,
    isPostpartum    : {required:{isPregnancy: true}},
    admissionAOG    : {required:{isPregnancy: true}},
    admissionWeeks  : {required:{isPregnancy: true, admissionAOGType: 1}, range:{minValue:0, maxValue:52}},
    admissionDays   : {required:{isPregnancy: true, admissionAOGType: 1}, range:{minValue:0, maxValue:6}},
    pregnancyType   : {required:{isPregnancy: true}},
    isHeterotopic   : {required:{isPregnancy: true, pregnancyType: 2}},
    abortionType    : {required:{isPregnancy: true, pregnancyType: 3}},
    ectopicType     : {required:{isPregnancy: true, pregnancyType: 4}},
    molarType       : {required:{isPregnancy: true, pregnancyType: 5}},
    isDelivered     : {required:{isPregnancy: true, isPostpartum: false, pregnancyType: [1, 2]}},
    institutionalDelivery   : {required:{isDelivered: true}},
    infantsNumber   : {required:{isDelivered: true}},

    //obstetric history
    obscoreG  : null,
    obscoreP  : null,
    obscoreFT : null,
    obscorePr : null,
    obscoreAb : null,
    obscoreLB : null,

    //delivery
    deliveryDate        : {required:{isDelivered: true}},
    deliveryAOGType     : null,
    deliveryAOG         : {required:{isDelivered: true}},
    deliveryWeeks       : {required:{isDelivered: true, deliveryAOGType: 1}, range:{minValue:0, maxValue:52}},
    deliveryDays        : {required:{isDelivered: true, deliveryAOGType: 1}, range:{minValue:0, maxValue:6}},
    deliveryManner      : {required:{isDelivered: true}},
    primaryRepeat       : {required:{isDelivered: true, deliveryManner: 1}},
    incision            : {required:{isDelivered: true, deliveryManner: 1}},
    CSBilateralSalpingectomy: {required:{isDelivered: true, deliveryManner: 1}},
    CSBTL               : {required:{isDelivered: true, deliveryManner: 1}},
    deliveryIndication  : {required:{isDelivered: true, deliveryManner: [1, 5, 6]}, minLength:1},
    morbidities         : {required:{deliveryManner: true}},
    neonatal            : {required:{isDelivered: true, isPostpartum: false}},
    isTOLAC             : {required:{isDelivered: true, isPregnancy: true}},

    //Complicated Pregnancy
    complicatedPregnancy: {required:{isPregnancy: true}},
    //Induced Labor
    isInduced: {required:{isPregnancy: true, isDelivered: true}},
    inducedIndication: {required:{isPregnancy: true, isDelivered: true, isInduced: true}},
    inducedMethod: {required:{isPregnancy: true, isDelivered: true, isInduced: true}},
    inducedComplication: {required:{isPregnancy: true, isDelivered: true, isInduced: true}},
    returnToOR: {required:{isPregnancy: true, complicatedPregnancy: true}},
    pcosHistory : null,
    pcosSymptoms : {required:{pcosHistory: true}},

    //gynecological
    gynecologicalDiagnosis: {required:{isGyne: true}, minLength: 1},

    //MIGS
    MIGSSurgeon     : null,
    MIGSSurgeonPSGE : { required: { MIGSSurgeon: 1, MIGSSurgeonPSRM: null } },
    MIGSSurgeonPSRM : { required: { MIGSSurgeon: 1, MIGSSurgeonPSGE: null } },
    MIGSAssist      : null,
    MIGSAssistPSGE  : { required: { MIGSAssist: 1, MIGSAssistPSRM: null } },
    MIGSAssistPSRM  : { required: { MIGSAssist: 1, MIGSAssistPSGE: null } },
    //discharge
    dischargeDate   : null,
    motherCondition : null,
    antecedentType  : {required:{motherCondition: 3}},
    // Removed because of June 2 Revisions
    //antecedentCause : {required:{motherCondition: 3}},
    deathTiming     : {required:{motherCondition: 3}},
    deathReviewed   : {required:{motherCondition: 3}}
};

export const caseValidationLabels = {
    //admission section
    admissionDate   : 'Date of Admission',
    age             : 'Patient Age on Admission',
    weight          : 'Patient\'s Weight',
    height          : 'Patient\'s Height',
    bmi             : 'Patient\'s BMI',
    room            : 'Room',
    admissionAOG    : 'Admission AOG',
    admissionWeeks  : 'Admission Weeks',
    admissionDays   : 'Admission Days',
    caseFormType    : 'Identify Case Type',
    pregnancyType   : 'Pregnancy Type',
    abortionType    : 'Abortion Type',
    ectopicType     : 'Ectopic Type',
    molarType       : 'Molar Type',
    infantsNumber   : 'Number of Infants',
    neonatal        : 'Neonatal',

    pcosHistory     : 'Does patient have a history of PCOS?',
    pcosSymptoms    : 'Please identify PCOS symptoms.',
    isPostpartum    : 'Is this a postpartum admission?',

    //obstetric history
    obscoreG  : 'OB Score G',
    obscoreP  : 'OB Score P',
    obscoreFT : 'OB Score FT',
    obscorePr : 'OB Score Pr',
    obscoreAb : 'OB Score Ab',
    obscoreLB : 'OB Score LB',

    //delivery
    isDelivered         : 'Has patient delivered ?',
    institutionalDelivery: 'Is Institutional Delivery?',
    deliveryDate        : 'Date of Delivery',
    deliveryAOG         : 'Delivery AOG',
    deliveryWeeks       : 'Delivery AOG Weeks',
    deliveryDays        : 'Delivery AOG Days',
    deliveryManner      : 'Manner of Delivery',
    primaryRepeat       : 'Primary or Repeat',
    incision            : 'Incision',
    CSBilateralSalpingectomy: 'Was Bilateral Salpingectomy performed during CS?',
    CSBTL               : 'Was BTL performed during CS?',
    deliveryIndication  : 'Delivery Indication',
    morbidities         : 'Morbidities',
    isTOLAC             : 'Did patient undergo TOLAC?',

    complicatedPregnancy: 'Is Case a Complicated Pregnancy?',

    isInduced  : 'Was labor induced?',
    inducedIndication: 'Specify indication of complicated pregnancy',
    inducedMethod    : 'Specify method of complicated pregnancy',
    inducedComplication: 'Specify complication of complicated pregnancy',
    returnToOR: 'Returned to OR',

    //gynecological
    gynecologicalDiagnosis  : 'Gynecologoical Diagnosis',

    hasFailedMIS    : 'Has failed MIS Procedure?',

    //MIGS
    MIGSSurgeon     : 'MIGS Surgeon',
    MIGSSurgeonPSGE : 'Surgeon PSGE Fellow',
    MIGSSurgeonPSRM : 'Surgeon PSRM Fellow',
    MIGSAssist      : 'MIGS Assistant',
    MIGSAssistPSGE  : 'Assist PSGE Fellow',
    MIGSAssistPSRM  : 'Assist PSRM Fellow',

    //discharge
    dischargeDate   : 'Discharge Date',
    motherCondition : 'Mother Condition',
    antecedentType  : 'Antecedent Type',
    antecedentCause : 'Antecedent Cause',
    deathTiming     : 'Timing of Death',
    deathReviewed   : 'Mortality reviewed by department/steering committee?'
};
